module.exports = __webpack_public_path__ + "static/media/daftar_peserta_ekskul.63471e71.png";